"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppModel = void 0;
const V5BaseModel_1 = require("./base/V5BaseModel");
const ide_lib_reactor_data_layer_1 = require("@journeyapps-platform/ide-lib-reactor-data-layer");
class AppModel extends V5BaseModel_1.V5BaseModel {
    constructor(details) {
        super('app', details);
        this.deployments = new ide_lib_reactor_data_layer_1.Collection();
    }
    deployment(instanceID) {
        return this.deployments.items.find((dep) => {
            return dep.options.model.id === instanceID;
        });
    }
    async loadDeployments() {
        return this.deployments.load(async () => {
            const client = this.options.clients.provisionDeployServiceClient();
            const deployments = await client.listDeployments({
                app_id: this.id
            });
            return deployments.map((deployment) => {
                const conf = this.options.banks.deploymentBank.upsert(deployment);
                conf.setOrg(this.model.org_id);
                return conf;
            });
        });
    }
    async updateLocks(lock) {
        await this.options.clients.provisionAccountsV5Client().updateAppLocks({
            id: this.id,
            locked: lock
        });
        await this.reload();
    }
    get label() {
        return this.model.name;
    }
    async reload() {
        this.options.model = await this.options.clients.provisionAccountsV5Client().getApp({
            id: this.id
        });
    }
    async getParents() {
        return [await this.getOrg()];
    }
    get org_id() {
        return this.options.model.org_id;
    }
    isLegacy() {
        return !this.options.model.source;
    }
    async getResourceSelector() {
        return {
            ...(await super.getResourceSelector()),
            labels: {
                locked: this.model.locked ? 'true' : 'false'
            }
        };
    }
}
exports.AppModel = AppModel;
